import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { BACKGROUND_REQUEST } from './auth.context';
import { AuthService } from './auth.service';
import { AuthUtils } from './auth.utils';
// import { FuseLoadingService } from '@fuse/services/loading';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  /**
   * Constructor
   */
  constructor(
    private _authService: AuthService, // private fuseLoadingService: FuseLoadingService,
  ) {}

  /**
   * Intercept
   *
   * @param req
   * @param next
   */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // Clone the request object
    let newReq = req.clone();

    // Request
    //
    // If the access token didn't expire, add the Authorization header.
    // We won't add the Authorization header if the access token expired.
    // This will force the server to return a "401 Unauthorized" response
    // for the protected API routes which our response interceptor will
    // catch and delete the access token from the local storage while logging
    // the user out from the app.

    if (
      this._authService.accessToken &&
      !AuthUtils.isTokenExpired(this._authService.accessToken)
    ) {
      newReq = req.clone({
        headers: req.headers.set(
          'Authorization',
          'Bearer ' + this._authService.accessToken,
        ),
      });
    }

    // Response
    return next.handle(newReq).pipe(
      tap((response) => {
        if (
          response instanceof HttpResponse &&
          (response.status === 200 || response.status === 201)
        ) {
          // this.fuseLoadingService.hide();
        }
      }),
      catchError((error) => {
        // Catch "401 Unauthorized" responses
        if (error instanceof HttpErrorResponse) {
          // this.fuseLoadingService.hide();

          if (error.status === 401 && !req.context.get(BACKGROUND_REQUEST)) {
            // Sign out
            this._authService.signOut();

            // Reload the app
            location.reload();
          }
        }

        return throwError(error);
      }),
    );
  }
}
